import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { SelectRegionalLanguage } from '../../layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';
import { CancelRequestsService } from '../../+shared/services/cancel-requests.service';
import { filter, Subscription, take, tap } from 'rxjs';
import { langs } from 'projects/shared/models/category';

export interface LocalizedText {
  en: string;
  ar: string;
}

export interface MaintenanceData {
  title: LocalizedText;
  body: LocalizedText;
}

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  _subscription = new Subscription();

  data!: MaintenanceData;

  language$ = this._store.selectSignal(SelectRegionalLanguage);

  constructor(
    private titleService: Title,
    private _store: Store,
    private _cancelRequestsService: CancelRequestsService,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Under Maintenance - Card4Games');
    this.getMaintenanceData();
  }

  getMaintenanceData() {
    this._subscription.add(
      this._cancelRequestsService.maintenanceModeData
        .pipe(
          filter((res) => res !== null),
          tap((res) => {
            // Update data if received from server
            if (res?.title && res?.body) {
              this.data = res as MaintenanceData;
            }
          }),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
